/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Field_Invite_Code_HintInputs */

const en_auth_field_invite_code_hint = /** @type {(inputs: Auth_Field_Invite_Code_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From your trainer's invite email. Leave it empty if you don't have one.`)
};

const pl_auth_field_invite_code_hint = /** @type {(inputs: Auth_Field_Invite_Code_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z e-maila z zaproszeniem od trenera. Zostaw puste, jeśli go nie masz.`)
};

/**
* | output |
* | --- |
* | "From your trainer's invite email. Leave it empty if you don't have one." |
*
* @param {Auth_Field_Invite_Code_HintInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_field_invite_code_hint = /** @type {((inputs?: Auth_Field_Invite_Code_HintInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Field_Invite_Code_HintInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_field_invite_code_hint(inputs)
	return en_auth_field_invite_code_hint(inputs)
});